import React, { useEffect, useState } from 'react';
import NavBar from "../../Componants/NavBar";
import { useNavigate } from "react-router-dom";
import CardLage from "../../Componants/CardLage";
import TableParticular from "../../Componants/Particular/TableParticular";
import { Ajax } from "../../Service/ajax";
import { GridLoader } from "react-spinners";
import AlertSuccess from "../../Componants/AlertSuccess";
import Footer from "../../Componants/Footer";
import {convertDate} from "../../config/AppConfig";
import { useMediaQuery } from 'react-responsive';
import Swal from "sweetalert2";
import SubscriptionSection from "../../Componants/SubscriptionSection";
import {security} from "../../env/Environment";
import EvaluationSection from "../../Componants/EvaluationSection";
export default function PrHomeView(){
    const navigate = useNavigate();
    const session = sessionStorage.getItem("session");
    const [loading, setLoading] = useState(false);
    const [subscriptions, setSubscriptions]=useState([]);
    const success = sessionStorage.getItem("success");
    const isMediumScreen = useMediaQuery({ maxWidth: 991 });
    const isSmallScreen = useMediaQuery({ maxWidth: 575 });
    const [appName, setAppName]=useState('');
    const [description, setDescription]=useState('');
    const [subscriptionsPlans, setSubscriptionsPlans]=useState([]);
    const[nbSubs, setNbSubs]=useState({
        active:0,
        expired:0,
        canceled:0
    })
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("default");


    useEffect(() => {
        const uniqueCategories = [];

        subscriptions.forEach((item) => {
            const category = item.category || "default"; // Remplacer null par "default"
            if (!uniqueCategories.includes(category)) {
                uniqueCategories.push(category); // Ajouter uniquement si absent
            }
        });

        setCategories(uniqueCategories); // Mettre à jour l'état avec les catégories uniques
        console.log(categories);
    }, [subscriptions]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                // Récupération des informations d'application
                const appResponse = await Ajax.getRequest(`/exposed/v1/sub/application/${security.ntk_sub_cmp}/subscription/retrieve`);
                setAppName(appResponse.data.object.name);
                setDescription(appResponse.data.object.description);

                if (appResponse.data.object.subscriptionPlans.length > 0) {
                    const transformedPlan = appResponse.data.object.subscriptionPlans.map(item => ({
                        id: item.id,
                        title: item.title,
                        infos: item.infos,
                        options: item.values,
                        price: item.price,
                        periodicity: item.periodicity,
                        currency: item.devise,
                        category: item.category ? item.category : 'default',
                    }));
                    setSubscriptionsPlans(transformedPlan);
                }

                // Vérification de la session
                if (!session) {
                    window.location.replace(window.location.origin);
                    return;
                }

                // Récupération des abonnements utilisateur
                const userResponse = await Ajax.getRequest(`/api/v1/sub/subscription/user/retrieve`);
                let actifCount = 0, expiredCount = 0, canceledCount = 0;

                if (userResponse.data.object.length > 0) {
                    const transformedSubscriptions = userResponse.data.object.map(item => {
                        if (item.status === "ACTIVE") {
                            actifCount++;
                        } else if (item.status === "EXPIRED") {
                            expiredCount++;
                        } else {
                            canceledCount++;
                        }
                        return {
                            id: item.id,
                            name: item.name,
                            subscription: item.subscription,
                            price: item.crc + "" + item.price,
                            periodicity: item.periodicity,
                            start_time: convertDate(item.start_time),
                            end_time: convertDate(item.end_time),
                            status: item.status
                        };
                    });
                    setSubscriptions(transformedSubscriptions);
                    setNbSubs({ active: actifCount, expired: expiredCount, canceled: canceledCount });
                }
            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [navigate, session]);

    return(
        <>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <GridLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div className="layout-wrapper layout-content-navbar layout-without-menu">
                    <div className="layout-container">
                        <div className="layout-page">
                            <NavBar route={"Organisation"}/>
                            <div className="content-wrapper">
                                <div className="container-xxl flex-grow-1 container-p-y">
                                    {success && <AlertSuccess/>}
                                    <div className="row">
                                        <div
                                            className="col-lg-6 col-md-6 col-sm-12 order-0">
                                            <CardLage
                                                title={"BIENVENUE | KARIBU | WELCOME"}
                                                subtitle={"Gérer sur cet espace tous les produits et services auxquels vous êtes abonnés."}
                                                type={"particular"}
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="card mb-4">
                                                <div className="card-widget-separator-wrapper">
                                                    <div className="card-body card-widget-separator">
                                                        <div className="row gy-4 gy-sm-1">
                                                            <div className="col-sm-6 col-lg-4">
                                                                <div
                                                                    className={`d-flex justify-content-between align-items-start card-widget-2 ${!isMediumScreen && !isSmallScreen ? 'border-end' : ''} pb-3 pb-sm-0`}>
                                                                    <div>
                                                                        <h2 className="mb-1">{nbSubs.active}</h2>
                                                                        <p className="mb-0">Actifs</p>
                                                                    </div>
                                                                    <span
                                                                        className="badge bg-label-primary rounded p-2 me-sm-4">
                  <i className="bx bx-check-double bx-sm"></i>
                </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6 col-lg-4">
                                                                <div
                                                                    className={`d-flex justify-content-between align-items-start card-widget-2 ${!isMediumScreen && !isSmallScreen ? 'border-end' : ''} pb-3 pb-sm-0`}>
                                                                    <div>
                                                                        <h2 className="mb-1">{nbSubs.canceled}</h2>
                                                                        <p className="mb-0">Annulés</p>
                                                                    </div>
                                                                    <span
                                                                        className="badge bg-label-secondary rounded p-2 me-lg-4">
                  <i className="bx bx-check bx-sm"></i>
                </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6 col-lg-4">
                                                                <div
                                                                    className="d-flex justify-content-between align-items-start">
                                                                    <div>
                                                                        <h2 className="mb-1">{nbSubs.expired}</h2>
                                                                        <p className="mb-0">expirés</p>
                                                                    </div>
                                                                    <span
                                                                        className="badge bg-label-danger rounded p-2">
                  <i className="bx bx-x bx-sm"></i>
                </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="card mb-4">
                                        <TableParticular title={"Mes Abonnements"}
                                                         content={subscriptions} onUpdateSubscriptions={(activeCount, expiredCount, canceledCount) => {
                                            setNbSubs({
                                                active: activeCount,
                                                expired: expiredCount,
                                                canceled: canceledCount
                                            });
                                        }}/>
                                    </div>
                                    <SubscriptionSection appName={appName} appDescription={description}
                                                         subscriptions={subscriptionsPlans} cmp={security.ntk_sub_cmp} category={category} setCategory={setCategory} categories={categories}/>
                                    <EvaluationSection/>
                                </div>
                                <div className="content-backdrop fade"></div>
                            </div>
                            <Footer/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
